import * as mobxReact from 'mobx-react';
import { CONNECTION_TYPE, ConnectionFormVM, FormInputType, zoomWebinarTypes } from '../connection-form.viewmodel';
import { hasPermission } from '../../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../../api/roles.dao';
import * as mobx from 'mobx';
import { ConnectionFields, fieldsForLinkedKnovio, fieldsWithoutCopyButton } from '../../../../../../../modules/connections/config';
import { FormVmValueValidationStatus } from '../../../../../../../infrastructure/form-viewmodel-controller';
import React, { Fragment } from 'react';
import { FormField } from '../../../../../../global/form/form-field/form-field';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { CopyButton } from '../../../../../../global/copy-button/copy-button';
import Text from '../../../../../../global/text/text';
import Spinner from '../../../../../../global/spinner/spinner';
import { WarningIcon } from '../../../../../../global/icons/icons';
import { meetingWebinarErrorMessage, meetingWebinarSuccessMessage } from '../../../../../../../infrastructure/utils/connections.utils';
import CheckMarkSVG from '../../../../../../../images/svg/icons8-checkmark';
import DefaultButton from '../../../../../../global/default-button/default-button';
import { getKnovioPresentationUrl } from '../../../../../../../infrastructure/utils/knovio.utils';
import { connectionsDetailsLabels } from '../../../../../../../constants/connections-labels.constants';
import { ConnectionItemFormField } from '../connection-form.presentation';
import { KnovioLabel } from '../../../../../../../api/connections.dao';

export const FieldsWrapper = mobxReact.observer((props: { formVM: ConnectionFormVM }): JSX.Element => {
    const formData = props.formVM.getConnectionFormDataVM();
    const connectionTemplateName = props.formVM.connectionTemplateName;
    const knovioLink = props.formVM.knovioLinkVM;
    const oneclickStartLivestreamLink = props.formVM.oneclickStartLivestreamLinkVM;
    const labels = connectionsDetailsLabels();
    const knovioPreviewPopover = props.formVM.knovioPreviewLinkPopoverVM;
    const connectionType = props.formVM[CONNECTION_TYPE];
    const fields = props.formVM.getFormFields();
    const formFields = props.formVM.isMeetingConnectionsForm || !!props.formVM.meetingApiParams.meetingId
        ? fields
        : fields.filter(x => x.name !== ConnectionFields.MEETING_UNIQUE_REFERENCE);
    const isShowPreviewButton = hasPermission(Permission.PREVIEW_KNOVIO_CONNECTION) && knovioPreviewPopover?.isInstanceReady;
    const fieldPermissions = {
        'hostLink': hasPermission(Permission.HOST_MANAGEMENT)
    };

    return (
        <form className='oe-form'>
            <div className='oe-form__body'>
                {
                    ...formFields.filter(field => {
                        return !Object.entries(fieldPermissions).some(permission => permission[0] === field.name && permission[1] === false);
                    }).map((formField, i) => {
                        const isToggleType = formField.fieldType === FormInputType.Toggle;
                        const onChange = mobx.action(value => {
                                formData.setValue(formField.name, value);
                            }
                        );
                        const onBlur = mobx.action(() => {
                            formData.setValueTouched(formField.name);
                            props.formVM.getWebinarDetails(formField.name, formField.value as string);
                        });

                        const onClick = isToggleType
                            ? () => props.formVM.toggleClickHandler(formField.name)
                            : undefined
                        ;

                        formField.readOnly = !isToggleType ? formField.readOnly : props.formVM.checkDisabledStatus(formField.name);

                        const isLinkedKnovio = props.formVM.initialValues.draft || (props.formVM.isEdit() && !!props.formVM.knovioConnectionStatus);
                        const displaySpecificField = fieldsForLinkedKnovio.includes(formField.name as ConnectionFields)
                            ? isLinkedKnovio
                            : true;
                        if (!displaySpecificField) return;

                        const fieldProps = {...formField, onChange: onChange, onBlur: onBlur, onClick: onClick};
                        const {valid, touched, validationMessage} = formField.readOnly ? {
                            valid: true,
                            touched: false
                        } as FormVmValueValidationStatus : formField;
                        const showCopyBtn = !(fieldsWithoutCopyButton as string[])
                            .includes(formField.name);

                        const isConnectionFieldType = formField.name === ConnectionFields.TYPE;

                        return (
                            <Fragment key={`${formField.name + i}`}>
                                <FormField
                                    className={classnames({'row': formField.fieldType === FormInputType.Checkbox})}
                                    labelFor={formField.fieldType === FormInputType.RichTextInput ? formField.name : null}
                                    label={formField.fieldType !== FormInputType.Toggle
                                        ? <FormattedMessage
                                            id={`oe.input.${formField.name}`}
                                            description='Input label'
                                            defaultMessage={formField.label}
                                        />
                                        : null
                                    }
                                >
                                    <div
                                        style={{'order': formField.fieldType === FormInputType.Checkbox ? -1 : 'initial'}}
                                        className={classnames('', {
                                            'flex': formField.fieldType !== FormInputType.Toggle,
                                            'start': formField.fieldType === FormInputType.Textarea
                                        })}
                                    >
                                        <ConnectionItemFormField connectionType={connectionType} {...fieldProps} />
                                        {showCopyBtn &&
                                            (<CopyButton copyValue={'' + formField.value} className='m-left-10px'
                                                         disabled={!formField.value}/>)
                                        }
                                    </div>
                                    {isConnectionFieldType && connectionTemplateName &&
                                        <div className='connection-form__template-name'>
                                            <span className='connection-form__template-name-label'>
                                                <FormattedMessage
                                                    id='oe.connection.template'
                                                    defaultMessage='Connection Template{suffix}'
                                                    description='label'
                                                    values={{suffix: ':'}}
                                                />
                                            </span>
                                            <Text message={connectionTemplateName} withEllipsis/>
                                        </div>
                                    }
                                    <>
                                        {!valid && touched &&
                                            <span className='oe-form-field__error'>
                                            <FormattedMessage {...validationMessage} values={{ fieldName: formField.label}} />
                                        </span>}
                                        {formField.name === ConnectionFields.SHOWCASE_PAGE_PATH &&
                                            <span className='oe-form-field__info'>
                                            <FormattedMessage
                                                id='oe.room.showcasePagePathRequirements'
                                                description='Input info text'
                                                defaultMessage={`Please enter the Page Path of 
                                                    the ${KnovioLabel.OEStream} within the embedded Showcase for this event.`}
                                            />
                                        </span>
                                        }
                                        {props.formVM.isMeetingConnectionsForm
                                            && !props.formVM.isEdit()
                                            && zoomWebinarTypes.includes(formData.type)
                                            && formField.name === ConnectionFields.CONNECTION_ID &&
                                            <>
                                                {props.formVM.loadWebinarDetails
                                                    ? <div className='__loading'>
                                                        <Spinner />
                                                    </div>
                                                    : props.formVM.webinarConnectionStatus === false
                                                        ? <div className='m-top-14px flex center'>
                                                            <div className='connection-form__warning-icon'>
                                                                <WarningIcon className='warning m-right-10px' />
                                                            </div>
                                                            <div>
                                                                {meetingWebinarErrorMessage[formData.type]}
                                                            </div>
                                                        </div>
                                                        : props.formVM.webinarConnectionStatus === true
                                                            ? <div className='m-top-14px flex center'>
                                                                <div className='connection-form__check-mark-icon m-right-10px'>
                                                                    <CheckMarkSVG />
                                                                </div>
                                                                <div>
                                                                    {meetingWebinarSuccessMessage[formData.type]}
                                                                </div>
                                                            </div>
                                                            : null
                                                }
                                            </>
                                        }
                                    </>
                                    {isConnectionFieldType && formData.type === 'Knovio' && props.formVM.isEdit() &&
                                        <div className='connection-form__knovio-connection'>
                                            {
                                                props.formVM.knovioConnectionStatus === null
                                                    ? <div className='connection-form__knovio-connection-status-block'>
                                                        <Spinner />
                                                    </div>
                                                    : (props.formVM.knovioConnectionStatus
                                                            ? <div className='connection-form__knovio-connection__wrappper'>
                                                                <div className='connection-form__knovio-connection-status-block'>
                                                                    <div className='connection-form__check-mark-icon m-right-10px'>
                                                                        <CheckMarkSVG />
                                                                    </div>
                                                                    <div>
                                                                        <FormattedMessage
                                                                            id='oe.connections.connectionIsLinkedKnovio'
                                                                            description='Info text'
                                                                            defaultMessage={`Connection is linked to ${KnovioLabel.OEStream}`}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {isShowPreviewButton && <div className='connection-form__knovio-connection-status-button'>
                                                                    <DefaultButton
                                                                        modifier={['fat', 'confirm-safe']}
                                                                        text={<FormattedMessage id='oe.connections.manageInKnovio' description='Button text' defaultMessage='Preview' />}
                                                                        onClick={knovioPreviewPopover?.openPopover?.bind(knovioPreviewPopover)}
                                                                        disabled={!knovioLink.isValid}
                                                                    />
                                                                </div>}

                                                            </div>
                                                            : <div className='connection-form__knovio-connection__wrappper'>
                                                                <div className='connection-form__knovio-connection-status-block'>
                                                                    <div className='connection-form__warning-icon'>
                                                                        <WarningIcon className='warning m-right-4px' />
                                                                    </div>
                                                                    <div>
                                                                        <FormattedMessage
                                                                            id='oe.connections.connectionIsNotLinkedKnovio'
                                                                            description='Info text'
                                                                            defaultMessage={`Connection is not linked to ${KnovioLabel.OEStream}`}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className='oe-form-field__info'>
                                                                    <FormattedMessage
                                                                        id='oe.connections.embedCodeIDNotFoundInKnovio'
                                                                        description='Info text'
                                                                        defaultMessage='Please enter a valid Embed Code ID'
                                                                    />
                                                                </div>
                                                            </div>
                                                    )}
                                        </div>}
                                </FormField>

                                {formField.name === ConnectionFields.EMBED_CODE_ID && formData.type === 'Knovio' &&
                                    <FormField label={<FormattedMessage id='knovioLink' description='Input label' defaultMessage={`${KnovioLabel.Project} Link`}/>}>
                                        <div style={{order: 'initial'}} className='flex'>
                                            <input
                                                value={knovioLink.getValue() || ''}
                                                onChange={e => knovioLink.setValue(e.target.value)}
                                                type='text'
                                                className='oe-form-field__control'
                                            />
                                            {showCopyBtn && <CopyButton copyValue={knovioLink.getValue()} className='m-left-10px' disabled={!knovioLink.isValid}/>}
                                        </div>
                                        <span className='oe-form-field__error'>
                                        {knovioLink.getValue() && !knovioLink.isValid && <FormattedMessage id='oe.validation.urlFormatInvalid'/>}
                                    </span>
                                        <span className='oe-form-field__info'>
                                        <FormattedMessage
                                            id='oe.room.knovioLinkRequirements'
                                            description='Input info text'
                                            defaultMessage={`Please enter the ${KnovioLabel.Project} link in the following format - {prefix}`}
                                            values={{
                                                prefix: `${getKnovioPresentationUrl()}...`
                                            }}
                                        />
                                    </span>
                                    </FormField>
                                }

                                {formField.name === ConnectionFields.EMBED_CODE_ID && formData.type === 'Knovio' &&
                                    <FormField label={labels.ONECLICK_START_LIVESTREAM_LINK()}>
                                        <div style={{order: 'initial'}} className='flex'>
                                            <input
                                                value={oneclickStartLivestreamLink.getValue() || ''}
                                                onChange={e => oneclickStartLivestreamLink.setValue(e.target.value)}
                                                type='text'
                                                className='oe-form-field__control'
                                            />
                                            {showCopyBtn && <CopyButton
                                                copyValue={oneclickStartLivestreamLink.getValue()}
                                                className='m-left-10px'
                                                disabled={!oneclickStartLivestreamLink.isValid}
                                            />}
                                        </div>
                                        <span className='oe-form-field__error'>
                                            {oneclickStartLivestreamLink.getValue() && !oneclickStartLivestreamLink.isValid &&
                                                <FormattedMessage id='oe.validation.urlFormatInvalid'/>}
                                        </span>
                                    </FormField>
                                }
                            </Fragment>
                        );
                    })
                }
            </div>
        </form>
    );
});
